.footer {
  background: #1d1d1d;
  color: #dcdcdc;
  position: relative;
  /* No top margin — main and footer meet directly so the page reads
     as one continuous surface regardless of list length. */
  margin-top: 0;
}

.mountain {
  width: 28vw;
  max-width: 100%;
  height: auto;
  display: block;
  opacity: 0.7;
}

.content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: var(--space-6);
  padding: var(--space-6) var(--space-6) var(--space-4);
}

.column h3,
.newsletter h3 {
  color: #f2f2f2;
  font-size: 0.8rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  margin-bottom: var(--space-3);
}

.column ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: var(--space-2);
  font-size: 0.85rem;
}

.column a {
  color: inherit;
}

.newsletter p {
  font-size: 0.85rem;
  line-height: 1.5;
}

.subscribe {
  margin-top: var(--space-3);
  background: var(--color-ember);
  border: 0;
  color: #111;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  padding: 10px 18px;
  border-radius: 4px;
  cursor: pointer;
}

.guarantee {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  left: -10%;
}

.guarantee img {
  width: 147px;
  height: auto;
}


.bottom {
  text-align: center;
  padding: var(--space-4);
  color: #8b8b8b;
  font-size: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

@media (max-width: 768px) {
  .content {
    padding: var(--space-5) var(--space-4);
  }

  .guarantee {
    justify-content: center;
  }
}
